import React from 'react';

import { SvgProps } from '../enums';

export const FlagBM: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_54959"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_54959)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#AF0100"
      />
      <mask
        id="mask1_270_54959"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_54959)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0038 6C11.0038 8.94339 11.2824 9.96565 12.9599 9.96565C14.6375 9.96565 15.0965 8.48282 14.9548 6H11.0038Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M13.05 7.70001C13.5195 7.70001 13.9 7.2523 13.9 6.70001C13.9 6.14773 13.5195 5.70001 13.05 5.70001C12.5806 5.70001 12.2 6.14773 12.2 6.70001C12.2 7.2523 12.5806 7.70001 13.05 7.70001Z"
          fill="#AF0100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M11.3967 9.15698C11.6955 9.82365 12.2183 10.157 12.9651 10.157C13.7068 10.157 14.2313 9.8281 14.5385 9.17034L11.3967 9.15698Z"
          fill="#5EAA22"
        />
        <path
          // eslint-disable-next-line max-len
          d="M11.8096 7.51535L11.5305 6.81921C12.0428 6.61384 12.5366 6.50983 13.0111 6.50983C13.4856 6.50983 13.9795 6.61384 14.4917 6.81921L14.2126 7.51535C13.7855 7.34411 13.3853 7.25983 13.0111 7.25983C12.6369 7.25983 12.2367 7.34411 11.8096 7.51535Z"
          fill="#82B2CB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.5 8C12.7761 8 13 7.77614 13 7.5C13 7.22386 12.7761 7 12.5 7C12.2239 7 12 7.22386 12 7.5C12 7.77614 12.2239 8 12.5 8Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.8 8.80005C13.0761 8.80005 13.3 8.57619 13.3 8.30005C13.3 8.02391 13.0761 7.80005 12.8 7.80005C12.5238 7.80005 12.3 8.02391 12.3 8.30005C12.3 8.57619 12.5238 8.80005 12.8 8.80005Z"
          fill="#8A4E22"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12 8.40002C12.2761 8.40002 12.5 8.17617 12.5 7.90002C12.5 7.62388 12.2761 7.40002 12 7.40002C11.7239 7.40002 11.5 7.62388 11.5 7.90002C11.5 8.17617 11.7239 8.40002 12 8.40002Z"
          fill="#AF0100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M13.7 8.40002C13.9762 8.40002 14.2 8.17617 14.2 7.90002C14.2 7.62388 13.9762 7.40002 13.7 7.40002C13.4239 7.40002 13.2 7.62388 13.2 7.90002C13.2 8.17617 13.4239 8.40002 13.7 8.40002Z"
          fill="#AF0100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M13.35 9.5C13.5433 9.5 13.7 9.27614 13.7 9C13.7 8.72386 13.5433 8.5 13.35 8.5C13.1567 8.5 13 8.72386 13 9C13 9.27614 13.1567 9.5 13.35 9.5Z"
          fill="#AF0100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.15 9.5C12.3433 9.5 12.5 9.27614 12.5 9C12.5 8.72386 12.3433 8.5 12.15 8.5C11.9567 8.5 11.8 8.72386 11.8 9C11.8 9.27614 11.9567 9.5 12.15 9.5Z"
          fill="#AF0100"
        />
        <rect width="9" height="7" fill="#2E42A5" />
        <mask
          id="mask2_270_54959"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="9"
          height="7"
        >
          <rect width="9" height="7" fill="white" />
        </mask>
        <g mask="url(#mask2_270_54959)">
          <path
            // eslint-disable-next-line max-len
            d="M-1.00214 6.49987L0.978339 7.36847L9.04494 0.94433L10.0896 -0.346436L7.97176 -0.636747L4.68159 2.1316L2.03334 3.99682L-1.00214 6.49987Z"
            fill="white"
          />
          <path
            d="M-0.731018 7.10849L0.277943 7.61255L9.71445 -0.466309H8.29775L-0.731018 7.10849Z"
            fill="#F50100"
          />
          <path
            // eslint-disable-next-line max-len
            d="M10.0021 6.49987L8.02166 7.36847L-0.0449371 0.94433L-1.08959 -0.346436L1.02824 -0.636747L4.31841 2.1316L6.96666 3.99682L10.0021 6.49987Z"
            fill="white"
          />
          <path
            // eslint-disable-next-line max-len
            d="M9.93457 6.93667L8.92561 7.44073L4.90745 3.98176L3.71615 3.59529L-1.1901 -0.341973H0.226597L5.13009 3.50184L6.43256 3.96525L9.93457 6.93667Z"
            fill="#F50100"
          />
          <path
            // eslint-disable-next-line max-len
            d="M3.50001 -0.5V-1H3.00001V-0.5H3.50001ZM3.50001 2.03237V2.53237H4.00001V2.03237H3.50001ZM-0.492249 2.03237V1.53237H-0.992249V2.03237H-0.492249ZM-0.492249 5.03237H-0.992249V5.53237H-0.492249V5.03237ZM3.50001 5.03237H4.00001V4.53237H3.50001V5.03237ZM3.50001 7.5H3.00001V8H3.50001V7.5ZM5.50001 7.5V8H6.00001V7.5H5.50001ZM5.50001 5.03237V4.53237H5.00001V5.03237H5.50001ZM9.50775 5.03237V5.53237H10.0078V5.03237H9.50775ZM9.50775 2.03237H10.0078V1.53237H9.50775V2.03237ZM5.50001 2.03237H5.00001V2.53237H5.50001V2.03237ZM5.50001 -0.5H6.00001V-1H5.50001V-0.5ZM3.50001 3.03237H4.00001V2.53237H3.50001V3.03237ZM0.507751 3.03237V2.53237H0.00775146V3.03237H0.507751ZM0.507751 4.03237H0.00775146V4.53237H0.507751V4.03237ZM3.50001 4.03237V4.53237H4.00001V4.03237H3.50001ZM5.50001 3.03237V2.53237H5.00001V3.03237H5.50001ZM5.50001 4.03237H5.00001V4.53237H5.50001V4.03237ZM8.50775 3.03237H9.00775V2.53237H8.50775V3.03237ZM8.50775 4.03237V4.53237H9.00775V4.03237H8.50775ZM3.50001 0H4.00001V-1H3.50001V0ZM4.00001 0V-0.5H3.00001V0H4.00001ZM4.00001 2.03237V0H3.00001V2.03237H4.00001ZM0.00775146 2.53237H3.50001V1.53237H0.00775146V2.53237ZM-0.492249 2.53237H0.00775146V1.53237H-0.492249V2.53237ZM0.00775146 2.53237V2.03237H-0.992249V2.53237H0.00775146ZM0.00775146 4.53237V2.53237H-0.992249V4.53237H0.00775146ZM0.00775146 5.03237V4.53237H-0.992249V5.03237H0.00775146ZM0.00775146 4.53237H-0.492249V5.53237H0.00775146V4.53237ZM3.50001 4.53237H0.00775146V5.53237H3.50001V4.53237ZM4.00001 7V5.03237H3.00001V7H4.00001ZM4.00001 7.5V7H3.00001V7.5H4.00001ZM4.00001 7H3.50001V8H4.00001V7ZM5.00001 7H4.00001V8H5.00001V7ZM5.50001 7H5.00001V8H5.50001V7ZM5.00001 7V7.5H6.00001V7H5.00001ZM5.00001 5.03237V7H6.00001V5.03237H5.00001ZM9.00775 4.53237H5.50001V5.53237H9.00775V4.53237ZM9.50775 4.53237H9.00775V5.53237H9.50775V4.53237ZM9.00775 4.53237V5.03237H10.0078V4.53237H9.00775ZM9.00775 2.53237V4.53237H10.0078V2.53237H9.00775ZM9.00775 2.03237V2.53237H10.0078V2.03237H9.00775ZM9.00775 2.53237H9.50775V1.53237H9.00775V2.53237ZM5.50001 2.53237H9.00775V1.53237H5.50001V2.53237ZM5.00001 0V2.03237H6.00001V0H5.00001ZM5.00001 -0.5V0H6.00001V-0.5H5.00001ZM5.00001 0H5.50001V-1H5.00001V0ZM4.00001 0H5.00001V-1H4.00001V0ZM3.50001 2.53237H0.507751V3.53237H3.50001V2.53237ZM0.00775146 3.03237V4.03237H1.00775V3.03237H0.00775146ZM0.507751 4.53237H3.50001V3.53237H0.507751V4.53237ZM4.00001 4.03237V3.03237H3.00001V4.03237H4.00001ZM5.00001 3.03237V4.03237H6.00001V3.03237H5.00001ZM8.50775 2.53237H5.50001V3.53237H8.50775V2.53237ZM9.00775 4.03237V3.03237H8.00775V4.03237H9.00775ZM5.50001 4.53237H8.50775V3.53237H5.50001V4.53237Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.00001 0H4.00001V2.53237H0.00775146V4.53237H4.00001V7H5.00001V4.53237H9.00775V2.53237H5.00001V0Z"
            fill="#F50100"
          />
        </g>
      </g>
    </g>
  </svg>
);
